export default __webpack_public_path__ + "static/media/ai.0b7fc66d.svg";